import axios from 'axios';

export default {
  getProductReviews,
  canUserReview,
  voteForReview,
  getSortByConstants
};

export function getProductReviews(params) {
  return axios.get('/api/contentReview/getProductReviews', { params });
}

export function canUserReview(params) {
  return axios.get('/api/contentReview/canUserReview', { params });
}

export function voteForReview(params) {
  return axios.post('/api/contentReview/voteForReview', params);
}

export function getSortByConstants() {
  return axios.get('/api/review/getSortByConstants');
}
